var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { getLogoutUrl } from '../../utils/identity_helper';
import { DDFW_TERMS_OF_SERVICE_URL } from '../../constants/values';
import Menu from '@doordash/component-menu';
import Button, { IconButton } from '@doordash/component-button';
import ListCell from '@doordash/component-list-cell';
import { HeaderTestId } from '../testId';
export var HeaderDropdown = function () {
    var handleLogOut = function () {
        var logoutUrl = getLogoutUrl();
        window.location.href = logoutUrl;
    };
    return (React.createElement(Menu, { menuContainerStyles: { width: '250px' }, renderMenuControl: function (_a) {
            var accessibilityAttributes = _a.accessibilityAttributes, describedBy = _a.describedBy;
            return (React.createElement(IconButton, __assign({ "aria-describedby": describedBy, accessibilityLabel: "User Menu", iconType: IconButton.IconTypes.PersonProfileLine, type: IconButton.Types.Plain, size: Button.Sizes.Large, "data-testid": HeaderTestId.ProfileMenuButton }, accessibilityAttributes)));
        }, content: [
            {
                title: 'Terms',
                listCellProps: {
                    href: DDFW_TERMS_OF_SERVICE_URL,
                    target: '_blank',
                    insetSize: ListCell.InsetSizes.Large,
                    'data-testid': HeaderTestId.TermsButton,
                },
                hasSeparator: true,
            },
            {
                title: 'Log Out',
                listCellProps: {
                    insetSize: ListCell.InsetSizes.Large,
                    'data-testid': HeaderTestId.LogoutButton,
                },
                onClick: function () { return handleLogOut(); },
            },
        ] }));
};
export default HeaderDropdown;
